import React from 'react';
import { Divider, InnerWrapper, MetaText, Pill, PillLabel, PillWrapper, ReasonLabel, ReasonRow, UserText } from './styles';
import { isRejectedStatus } from '../utils/status';

function formatDateTime(value) {
  if (!value) return '';

  // Force parse as LOCAL time (avoid timezone surprises)
  const [datePart, timePart] = value.split('T');
  const [year, month, day] = datePart.split('-').map(Number);
  const [hour, minute] = timePart.split(':').map(Number);

  const date = new Date(year, month - 1, day, hour, minute);

  return (
    date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }) +
    ', ' +
    date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
    })
  );
}

const StatusPill = ({ status, by, at, reason }) => {
  if (!status) return null;

  const pill = (
    <Pill status={status}>
      <PillLabel status={status}>
        {status}
      </PillLabel>
      <Divider />
      <MetaText>{formatDateTime(at)}</MetaText>
      <Divider />
      <UserText>{by}</UserText>
    </Pill>
  );

  const showReasonBelow =
    isRejectedStatus(status) && reason;

    return (
        <PillWrapper>
            <InnerWrapper>
                {pill}
                {showReasonBelow && (
                    <ReasonRow>
                        <ReasonLabel>Reason:</ReasonLabel>
                        {reason}
                    </ReasonRow>
                )}
            </InnerWrapper>
        </PillWrapper>
    );
};

export default StatusPill;